// --------------------------------------------------------------
// Created On: 2021-10-01
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import styles from "./AssociatedAssetgroupItem.module.scss";

// A single child asset group in the asset group modal.
export default function AssociatedAssetgroupItem(props: Props): Component {
  return (
    <Fragment>
      <div data-test="assetgroup-associated-asset-group-item" className={`${styles.body} px-4 py-2`}>
        {props.name}
      </div>
    </Fragment>
  );
}

interface Props {
  assetgroupId: number;
  name: string;
}
